import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {YTBesprechung} from '../../../generated-api';

@Injectable({
  providedIn: 'root'
})
export class YtbesprechungStoreService {
  private readonly _selectedYTBesprechung = new BehaviorSubject<YTBesprechung>(null);
  readonly selectedYTBesprechung$ = this._selectedYTBesprechung.asObservable();

  get selectedYTBesprechung(): YTBesprechung {
    return this._selectedYTBesprechung.getValue();
  }

  set selectedYTBesprechung(val: YTBesprechung) {
    this._selectedYTBesprechung.next(val);
  }

  private readonly _loading = new BehaviorSubject<boolean>(false);
  readonly loading$ = this._loading.asObservable();

  get loading(): boolean {
    return this._loading.getValue();
  }

  set loading(val: boolean) {
    this._loading.next(val);
  }

  private readonly _searchError = new BehaviorSubject<string>(null);
  readonly searchError$ = this._searchError.asObservable();

  get searchError(): string {
    return this._searchError.getValue();
  }

  set searchError(val: string) {
    this._searchError.next(val);
  }
  constructor() { }
}
